import { CLAN_ACTIVE_UNITS_UPDATE, CLAN_INDUSTRIAL_RESOURCE_REACTIVE_UPDATE } from 'channels/clan/actions'

import { ACCOUNT_INFO_SUCCESS } from 'state/actions/account'
import { RESERVE_PRODUCE_SUBMIT_SUCCESS } from 'state/actions/reserve_produce'
import { RESERVE_PRODUCE_CANCEL_SUCCESS } from 'state/actions/reserve_produce_cancel'
import { COMMAND_CENTER_UPGRADE_SUCCESS } from 'state/actions/command_center_upgrade'
import { BUILDING_UPGRADE_SUCCESS } from 'state/actions/building_upgrade'
import { BUILDING_CONSTRUCTION_SUCCESS } from 'state/actions/building_construction'
import { CLAN_EXTENDED_INFO_UPDATE, CLAN_MANAGEMENT_UPDATE } from 'state/actions/CMT/ClanManagement'
import { DIVIDE_PROFITS_SUCCESS } from 'state/actions/CMT/MembersOperation'
import { RESET_CLAN } from '../actions/clan'

const initialState = {
    id: null,
    color: null,
    tag: null,
    name: null,
    emblem: null,
    industrial_resource: 0,
    treasury: {},
    token: null,
    reactive_channel: null,
    units_channel: null,
    units_number: null,
    invites_count: null,
    applications_count: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case RESET_CLAN: {
        return initialState
    }
    case ACCOUNT_INFO_SUCCESS: {

        if (!action.payload.clan) {
            return initialState
        }

        const {
            id,
            color,
            tag,
            name,
            emblem,
            industrial_resource,
            treasury,
            token,
            reactive_channel,
            units_channel,
            units_number,
        } = action.payload.clan

        return {
            ...state,
            id,
            color,
            tag,
            name,
            emblem,
            industrial_resource,
            treasury,
            token,
            reactive_channel,
            units_channel,
            units_number,
        }
    }
    case CLAN_ACTIVE_UNITS_UPDATE: {
        return {
            ...state,
            units_number: action.payload.units_number,
        }
    }
    case DIVIDE_PROFITS_SUCCESS: {
        return {
            ...state,
            treasury: {
                ...state.treasury,
                [action.currency]: state.treasury[action.currency] - action.delta,
            },
        }
    }
    case CLAN_MANAGEMENT_UPDATE: {
        return {
            ...state,
            applications_count: action.clan.applicationsCount,
            invites_count: action.clan.invitesCount,
        }
    }
    case CLAN_EXTENDED_INFO_UPDATE: {
        return {
            ...state,
            applications_count: action.payload.applications_count,
            invites_count: action.payload.invites_count,
        }
    }
    default:
        return industrialResourceReducer(state, action)
    }
}

const industrialResourceReducer = (state, action = {}) => {
    switch (action.type) {
    case RESERVE_PRODUCE_SUBMIT_SUCCESS:
    case BUILDING_CONSTRUCTION_SUCCESS:
    case COMMAND_CENTER_UPGRADE_SUCCESS:
    case BUILDING_UPGRADE_SUCCESS:
    case RESERVE_PRODUCE_CANCEL_SUCCESS: {
        return {
            ...state,
            industrial_resource: action.payload.industrialResourceBalance,
        }
    }
    case CLAN_INDUSTRIAL_RESOURCE_REACTIVE_UPDATE: {
        return {
            ...state,
            industrial_resource: action.payload.industrial_resource,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clan.js